import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';

export const selectEmpleador = (state: AppState) => state?.empleador;
export const selectEmpleadorUser = createSelector(selectEmpleador, (empleador) => empleador);
